import { Field, RichTextField, LinkField, ImageField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  ImagePropertiesParams,
  RenderingProps,
  TranslationOptionsParams,
} from '@/shared/shared.types';

export type C20CTAContentCardProps = RenderingProps<
  C20CTAContentCardFields,
  C20CTAContentCardParams
>;

export type C20CTAContentCardFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  FirstCTA?: LinkField;
  SecondCTA?: LinkField;
  ThirdCTA?: LinkField;
  Image?: ImageField;
};

export type C20CTAContentCardParams = {
  HeadlineTag?: string;
  FirstCTAStyle?: string;
  SecondCTAStyle?: string;
  CTAAlignment?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams &
  ImagePropertiesParams;
